/**
 * Current version of each legal document, also shown as its "last updated" date.
 * Strictly identical in the front and back repos (scripts/verifier-parite-regles.mjs):
 * the back refuses a checkout sent with another CGV version, and a sign-up sent
 * with another CGU version, so a one-sided bump would block every payment or
 * sign-up. Bump both repos in the same release; sign-ups still fail between the
 * back and front deploys of that release.
 */
export const LEGAL_VERSIONS = {
  cgu: '2026-09-17',
  cgv: '2026-10-20',
} as const;

export const LEGAL_VERSION_PATTERN = /^\d{4}-\d{2}-\d{2}$/;
